var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blog"}},[_c('vue-headful',{attrs:{"title":_vm.$t('pages.blog') + ' - Fernando Mata'}}),(!_vm.hasCalled)?_c('ContentLoader'):_vm._e(),_vm._l((_vm.posts),function(post){return _c('div',{key:post.name},[_c('article',{staticClass:"post"},[_c('header',[_c('div',{staticClass:"title"},[_c('h2',[_c('router-link',{attrs:{"to":{ 
            name: 'Entry', 
            params: { 
              year: _vm.getDate(post.post_date, 'year'), 
              month: _vm.getDate(post.post_date, 'month'), 
              day: _vm.getDate(post.post_date, 'day'), 
              title: post.post_name, 
              entry: post 
              } 
            }}},[_vm._v(_vm._s(post.post_title))])],1),_c('p',[_vm._v(_vm._s(_vm.$t('blog.published'))+" "+_vm._s(_vm.$d(new Date(post.post_date.replace(/-/g, "/")), 'short')))])])]),_c('p',{domProps:{"innerHTML":_vm._s(post.post_content)}})])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }